<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">{{ titre | translate }}</h1>
<h2 *ngIf="!isAppMobile" tabindex="-1" class="dsd-t-3 dsd-mb-md">
  {{ 'caad.modifier-fiserv.validation.titre' | translate }}
</h2>
<div *ngIf="formGroupLocal">
  <!-- Alerte information-->
  <dsd-alert *ngIf="particuliersCreditPlusQueUn" variant="information" tabindex="-1">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.information' | translate }}</h2>
    <p>{{ 'caad.modifier-fiserv.validation.alerte' | translate }}</p>
  </dsd-alert>
  <dsd-container>
    <!-- Adresse -->
    <ng-container>
      <h3 class="dsd-t-4 dsd-mb-sm">{{ titreAdressePostale | translate }}</h3>
      <p class="dsd-mb-0">
        <span class="valeur line-adresse">{{ adressePostale | adresse }}</span>
      </p>
      <div class="dsd-hr dsd-hr-deco dsd-mt-md dsd-mb-md"></div>
    </ng-container>
    <!-- Téléphone -->
    <ng-container>
      <h3 class="dsd-t-4 dsd-mb-sm">{{ titreTelephone | translate }}</h3>
      <p class="dsd-mb-0">
        <span class="libelle-credit"
          >{{ 'caad.modifier-fiserv.validation.numeroTelephonePrincipal' | translate }}&nbsp;</span
        >
        <span class="valeur">{{ formGroupLocal.controls.telephone.value | phone }}</span>
      </p>
      <div class="dsd-hr dsd-hr-deco dsd-mt-md dsd-mb-md"></div>
    </ng-container>
    <!-- Courriel -->
    <ng-container>
      <h3 class="dsd-t-4 dsd-mb-sm">{{ titreAdresseCourriel | translate }}</h3>
      <p class="dsd-mb-0">
        <span class="libelle-credit">{{ 'caad.accueil.libelle.adresseCourriel' | translate }}&nbsp;</span>
        <span class="valeur">{{ formGroupLocal.controls.courriel.value }}</span>
      </p>
    </ng-container>
  </dsd-container>

  <div class="zone-btn">
    <!-- Bouton Confirmer -->
    <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="soumettreFormulaire()">
      {{ 'caad.modifier-fiserv.validation.boutonConfirmer' | translate }}
    </dsd-button>
    <!-- Bouton Modifier -->
    <dsd-button full-width="xs" (dsdButtonClick)="naviguerVersModifier()">
      {{ 'caad.button.modifier' | translate }}
      <span class="dsd-sr-only"> {{ 'caad.accueil.libelle.horsEcran.modifierCoordonnees' | translate }}</span>
    </dsd-button>
    <!-- Bouton Annuler -->
    <dsd-button full-width="xs" (dsdButtonClick)="annulerModification()">
      {{ 'caad.button.annuler' | translate }}
    </dsd-button>
  </div>
</div>
